export default "__VITE_ASSET__3TheBTSC__"